export enum Step2Tabs {
    Login = 1,
    CreateAccount = 2,
}